import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";
import DeleteReceivingItemByBarcodeForm from "../../components/forms/receiving/DeleteReceivingItemByBarcodeForm";
import {
  generateUniqueNumber,
  updateObjectInArray,
} from "../../shared/utility";
import { SnackbarData, SnackbarType } from "../../components/Snackbar";

export function AddReceivingInvoiceViewModel(logout, addSnackbar) {
  const [isEdit, setIsEdit] = useState(false);
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [truckOptions, setTruckOptions] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [carrierOptions, setCarrierOptions] = useState([]);
  const [poOptions, setPoOptions] = useState([]);
  const [receiving, setReceiving] = useState(null);
  const [selectedItems, setSelectedItems] = useState(null);

  const createReceivingInvoice = async function (payload) {
    let callResult = await makePostApiCall("receivingInvoices/create", {
      ...payload,
      status: payload.status.value,
      truck_question_1: payload.truck_question_1.value,
      truck_question_2: payload.truck_question_2.value,
      truck_question_3: payload.truck_question_3.value,
      truck_question_4: payload.truck_question_4.value,
    });

    if (callResult.success) {
      if (payload.truck_selected.__isNew__) {
        const trucksResult = await getTruckOptionsForDropdown();
      }

      setReceiving(callResult.data);
      setIsEdit(true);
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Receiving invoice created",
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const updateReceivingInvoice = async function (payload) {
    console.log("a_pa", payload);
    let callResult = await makePutApiCall(
      `receivingInvoices/${receiving.id}`,
      payload
    );

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const addItemToReceiving = async function (values) {
    const payload = {
      invoice_id: receiving.id,
      lot_number: receiving.lot_number,
      ...values,
    };
    let callResult = await makePostApiCall("receivingItems/create", payload);

    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      const currReceivingItems = receiving.items ? receiving.items : [];
      setReceiving({
        ...receiving,
        items: [callResult.data.item, ...currReceivingItems],
        // barcodes: [...callResult.data.barcodes],
      });
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Item added",
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  const getProductOptionsForDropdown = async function () {
    let callResult = await makeGetApiCall(`productsForDropdown`);

    if (callResult.success) {
      setProductOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const getTruckOptionsForDropdown = async function () {
    let callResult = await makeGetApiCall(`allReceivingTrucksForDropdown`);

    if (callResult.success) {
      setTruckOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch trucks");
    }
  };

  const getSupplierOptionsForDropdown = async function () {
    let callResult = await makeGetApiCall(`suppliersForDropdown`);

    if (callResult.success) {
      setSupplierOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch suppliers");
    }
  };

  const getEmployeeOptionsForDropdown = async function () {
    let callResult = await makeGetApiCall(`usersForDropdown`);

    if (callResult.success) {
      setEmployeeOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch suppliers");
    }
  };

  const fetchPosForTruck = async function (truckId) {
    // let callResult = await makeGetApiCall(`fetchPosForTruck/${truckId}`);
    // if (callResult.success) {
    //   setPoOptions(callResult.data);
    // } else {
    //   if (callResult.errorStatus === 401) {
    //     logout();
    //   }
    //   showErrorModal("Could not fetch purchase orders");
    // }
  };

  const onFetchProductDetails = async function (productId) {
    let callResult = await makeGetApiCall(`products/${productId}`);

    if (callResult.success) {
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch product");
    }
    return callResult;
  };

  const deleteReceivingItemById = async function (deletedItem) {
    let callResult = await makePostApiCall(
      `deleteReceivingItem/${deletedItem.id}`
    );
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const currentItems = [...receiving.items];

      var itemIndex = currentItems.findIndex(
        (it) =>
          it.plu === deletedItem.plu && it.lot_number === deletedItem.lot_number
      );
      var itemToUpdate = currentItems[itemIndex];

      const newSubItems = itemToUpdate.subItems.filter(
        (it) => it.id !== deletedItem.id
      );

      itemToUpdate = {
        ...itemToUpdate,
        carton_count: itemToUpdate.carton_count - 1,
        subItems: newSubItems,
      };

      var payload = {
        index: itemIndex,
        item: itemToUpdate,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setReceiving({ ...receiving, items: newItems });
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const deleteReceivingItemByBarcode = async function (barcode) {
    let callResult = await makePostApiCall(
      `deleteReceivingItemByBarcode/${barcode}`
    );
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const deletedItem = callResult.data.item;
      const currentItems = [...receiving.items];

      var itemIndex = currentItems.findIndex(
        (it) =>
          it.plu === deletedItem.plu && it.lot_number === deletedItem.lot_number
      );
      var itemToUpdate = currentItems[itemIndex];

      const newSubItems = itemToUpdate.subItems.filter(
        (it) => it.id !== deletedItem.id
      );

      itemToUpdate = {
        ...itemToUpdate,
        carton_count: itemToUpdate.carton_count - 1,
        subItems: newSubItems,
      };

      var payload = {
        index: itemIndex,
        item: itemToUpdate,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setReceiving({ ...receiving, items: newItems });

      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const askDeleteReceivingItemById = function (item) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteReceivingItemById(item)}
          message={`Are you sure you want to return  ${item.product_name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  const updateReceivingItem = async function (payload) {
    let callResult = await makePutApiCall(
      `updateReceivingItem/${payload.id}`,
      payload
    );
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      // const newItems = receiving.items.filter((item) => item.id !== id);
      // setReceiving({ ...receiving, items: newItems });

      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openDeleteItemByBarcodePopup = function () {
    setEmptyModelOpen({
      childComponent: (
        <DeleteReceivingItemByBarcodeForm
          barcodeOptions={receiving.barcodes}
          buttonMessage="Delete"
          confirmAction={(barcode) => deleteReceivingItemByBarcode(barcode)}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  const getWarehouses = async function () {
    let callResult = await makeGetApiCall("warehousesForDropdown");
    if (callResult.success) {
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch warehouses");
    }
    return callResult;
  };

  const getWarehouseLocations = async function (warehouseId) {
    let callResult = await makeGetApiCall(
      `warehouseLocationsForDropdown/${warehouseId}`
    );
    if (callResult.success) {
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch warehouse locations");
    }
    return callResult;
  };

  const onDeleteReceivingInvoice = async function () {
    let callResult = await makePostApiCall(
      `deleteReceivingInvoice/${receiving.id}`
    );
    if (callResult.success) {
      setIsEdit(false);
      setReceiving(null);
      setPoOptions([]);
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Receiving restarted fresh",
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const onDeleteSelectedReceivingItems = async function (reason) {
    let callResult = await makePostApiCall(`deleteReceivingItemsByMultiple`, {
      receiving_id: receiving.id,
      items: selectedItems,
      reason: reason,
    });
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      const newItems = callResult.data.receiving_items;

      setReceiving({ ...receiving, items: newItems });
      setSelectedItems(null);

      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const askReturnSelectedItems = () => {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={(reason) => onDeleteSelectedReceivingItems(reason)}
          message={`Are you sure you want to return these items?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  const onUpdateUnitCostForReceivingItem = async function () {};

  const getCarriersForDropdown = async function () {
    let callResult = await makeGetApiCall(`carriersForDropdown`);
    if (callResult.success) {
      setCarrierOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  return {
    emptyModal,
    setEmptyModelOpen,
    truckOptions,
    getTruckOptionsForDropdown,
    fetchPosForTruck,
    supplierOptions,
    getSupplierOptionsForDropdown,
    getProductOptionsForDropdown,
    productOptions,
    onFetchProductDetails,
    poOptions,
    createReceivingInvoice,
    receiving,
    addItemToReceiving,
    askDeleteReceivingItemById,
    updateReceivingItem,
    openDeleteItemByBarcodePopup,
    isEdit,
    updateReceivingInvoice,
    employeeOptions,
    getEmployeeOptionsForDropdown,
    getWarehouses,
    getWarehouseLocations,
    onDeleteReceivingInvoice,
    askReturnSelectedItems,
    selectedItems,
    setSelectedItems,
    onUpdateUnitCostForReceivingItem,
    showErrorModal,
    getCarriersForDropdown,
    carrierOptions,
  };
}
